import Chart from 'chart.js/auto'
(function ($) {
  $(document).ready(function () {
    var estChart,investedChart;
    let compoundCalculator = 'compound-interest';

    const calculatorConstants = {
      'compound-interest': {
        'totalInvestment': { // in rupees
          default: 10000,
          min: 10000,
          max: 10000000
        },
        'timePeriod': {   // in rupees
          default: 5,
          min: 1,
          max: 25
        },
        'returnRate': {   // in yrs
          default: 15,
          min: 1,
          max: 50
        }
      }
    };

    let totalInvestment = calculatorConstants[compoundCalculator].totalInvestment.default;
    let timePeriod = calculatorConstants[compoundCalculator].timePeriod.default;
    let returnRate = calculatorConstants[compoundCalculator].returnRate.default;


    const totalInvestmentHTML = document.getElementById('total-investment');
    const investedAmountHTML = document.getElementById('invested-amount');
    const estAmountHTML = document.getElementById('est-amount');    
    const investmentTitle =  document.getElementById('investment-slider-title');
    
    const ctx = document.getElementById("mfChart").getContext("2d");
    let mfChart;

    function updatecompoundTextValues() {

       const totalReturnValue =calculatecompoundReturn();
       

            totalInvestmentHTML.innerHTML = '₹ ' + Number(totalInvestment).toLocaleString('en-IN');
            investedAmountHTML.innerHTML = '₹ ' + Number(totalReturnValue - totalInvestment).toLocaleString('en-IN');
            estAmountHTML.innerHTML = '₹ ' + Number(totalReturnValue).toLocaleString('en-IN');


           estChart = totalReturnValue - totalInvestment;
           investedChart = totalReturnValue;
    }

    

    /**
     * chart JS initialization
     */
    function drawChart() {
      mfChart = new Chart(ctx, {
        type: "doughnut",
        data: {
          labels: ["Total Investment Amount", "Total Interest"],
          datasets: [
            {
              label: "Compound Interest Calculator",
              data: [investedChart, estChart],
              cutout: "70%",
              backgroundColor: ["#43165C", "#E79D0D"],
              hoverOffset: 4,
            },
          ],
        },
        options: {
          responsive: false,
          locale: 'en-IN',
          maintainAspectRatio: false,
          layout: {
            padding: 30
          },
          plugins: {
            legend: {
              display: false,
            },
          },
        },
      });
    }
    
    /**
     * Rangeslider.js initialization
     */
    $('input[type="range"]').rangeslider({
      polyfill: false,

      // Default CSS classes
      rangeClass: "rangeslider",
      disabledClass: "rangeslider--disabled",
      horizontalClass: "rangeslider--horizontal",
      verticalClass: "rangeslider--vertical",
      fillClass: "rangeslider__fill",
      handleClass: "rangeslider__handle",

      onInit: function () {},

      onSlide: function (position, value) {},

      onSlideEnd: function (position, value) {},
    });

    /**
     * Forces input value to stay within the range
     */
    function forceValueRanges(input, type, forceMin = false) {
      const value = Number(input.val());
      const allowedMax = calculatorConstants[compoundCalculator][type].max;
      const allowedMin = calculatorConstants[compoundCalculator][type].min;
      if (value > allowedMax) {
        input.val(allowedMax);
      }

      function forceMinValues() {
        if (value < allowedMin && value) {
          input.val(allowedMin);
        }
      }

      if (forceMin) {
        forceMinValues();
      }
    };

    
    /**
     * Input field listeners
     */
    $('input#total-investment-input').on('input', function (event) {
      forceValueRanges($('input#total-investment-input'), 'totalInvestment');
      totalInvestment = Number(event.target.value);
      $('input#total-investment-slider').val(totalInvestment).change();
    });

    $('input#return-rate-input').on('input', function (event) {
      forceValueRanges($('input#return-rate-input'), 'returnRate', true);
      returnRate = Number(event.target.value);
      $('input#return-rate-slider').val(returnRate).change();
    });

    $('input#period-input').on('input', function (event) {
      forceValueRanges($('input#period-input'), 'timePeriod', true);
      timePeriod = Number(event.target.value);
      $('input#period-input-slider').val(timePeriod).change();
    });


    /**
     * Slider input listeners
     */
    $('input#total-investment-slider').on('input', function (event) {
      totalInvestment = Number(event.target.value);
      if (totalInvestment > 0) {
        $('input#total-investment-input').val(totalInvestment);
      }
    });

    $('input#return-rate-slider').on('input', function (event) {
      returnRate = Number(event.target.value);
      $('input#return-rate-input').val(returnRate);
    });

    $('input#period-input-slider').on('input', function (event) {
      timePeriod = Number(event.target.value);
      $('input#period-input').val(timePeriod);
    });



    $("input[type=number]").on("keydown", function(e) {
      let invalidChars = ["-", "+", "e"];
      if (invalidChars.includes(e.key)) {
          e.preventDefault();
      }
    });


    function calculatecompoundReturn() {
     const R = Number(returnRate)* 0.01; //return %
      const P = Number(totalInvestment); // Invested amount
      const T = Number(timePeriod);      
  
    //  const tableval = Math.round(P * R * T);

      return Math.round(P*Math.pow((1+R),T));
    }


    $(document).on('input', function() {
      mfChart.destroy();
     
      updateTextValues();
       drawChart();
    });

    
    $(".calculator_help_section").on("click", ".panel-trigger", (function() {
      var val = $(this).attr("val");
      $(".calculator_help_section").find(".panel-collapse:not('" + val + "')").slideUp("fast");
      var inactiveTab = $(".calculator_help_section").find(".panel-trigger:not([val='" + val + "'])");
      $(this).toggleClass("collapsed"),
      $(val).slideToggle("fast"),
      inactiveTab.hasClass("collapsed") && inactiveTab.removeClass("collapsed")
  }
  ));


  
  $(".btn-all").click((function() {
    $(".smooth-wrap").addClass("smooth-wrap2"),
    $(".btn-all").hide(),
    $(".btn-less").show()
}
));
$(".btn-less").click((function() {
    $(".smooth-wrap").removeClass("smooth-wrap2"),
    $(".btn-all").show(),
    $(".btn-less").hide()
}
));

    function updateTextValues() {
        return updatecompoundTextValues();
    }

    function calculate() {
      return calculatecompoundReturn() ;
    }

    function init() {
    
      updateTextValues();
        drawChart();
    }
    
    init();

  });
})(jQuery);